import { SelectedCustomer } from "pages/carteira/page";

import { PriceButton } from ".";
import { SkeletonLoading } from "components/skeleton-loading";
import { Box, Button, Flex, Grid, Text } from "@chakra-ui/react";
import { UsersIcon } from "./icons"; // Assuming we have an icon, or use a generic one
import { useApplicationContext } from "contexts/ApplicationContext";
import { SettingsIcon } from "@chakra-ui/icons";
import { useRouter } from "router-manager/parts";
import { GETLicensePayload } from "../user-licences/utils";
import { ReactNode } from "react";

export function LicencaUsuarioServiceCard({
  isLoading,
  priceDesc,
  title,
  licenseData,
  selectedCustomer
}: {
  isLoading?: boolean;
  title: string;
  priceDesc: ReactNode;
  licenseData: GETLicensePayload | undefined;
  selectedCustomer: SelectedCustomer;
}) {
  const router = useRouter();
  const { user } = useApplicationContext();

  const px = "25px";
  const titleContainerHeight = "80px";

  // Assuming licenseData has a count
  const masterLicenseCount = licenseData?.qtyLicenseMaster || 0;
  const vendedorLicenseCount =
    licenseData?.qtyLicenseVendedorOrOperacional || 0;

  return (
    <SkeletonLoading
      isLoading={!!isLoading}
      borderRadius="10px"
      bg="#fff"
      overflow="hidden"
    >
      <Flex
        justifyContent="space-between"
        flexDir="column"
        bg="#fff"
        borderRadius="10px"
        overflow="hidden"
        h="100%"
        border="1px solid var(--chakra-colors-custom-gray)"
      >
        <Flex
          px={px}
          w="100%"
          h={titleContainerHeight}
          alignItems="center"
          pos="relative"
          overflow="hidden"
          justifyContent="flex-start"
        >
          <Text
            fontSize={{ base: "18px", "2xl": "20px" }}
            fontWeight="semibold"
          >
            {title}
          </Text>
          <Box pos="absolute" bottom="-20px" right="35px">
            <UsersIcon /> {/* Need to define or import an icon */}
          </Box>
        </Flex>
        <Flex flexDir="column" px={px} py="15px" minH="215px">
          <Grid
            templateColumns="140px 2fr"
            gap="10px"
            alignItems="center"
            w="100%"
            mb="10px"
          >
            <Text fontWeight="semibold">Licença Master:</Text>
            <Flex alignItems="center" justifyContent="flex-end">
              <Text>{masterLicenseCount}</Text>
            </Flex>
            <Text fontWeight="semibold">Licença Vendedor:</Text>
            <Flex alignItems="center" justifyContent="flex-end">
              <Text>{vendedorLicenseCount}</Text>
            </Flex>
          </Grid>
          <Button
            my="10px"
            w="100%"
            size="sm"
            variant="outline"
            bg="#fff"
            onClick={() => router.push(`/confirm-licenses`)}
            leftIcon={<SettingsIcon />}
          >
            Configurar
          </Button>
        </Flex>
        <Box px={px} pb="15px" mt="auto">
          <PriceButton>{priceDesc}</PriceButton>
        </Box>
      </Flex>
    </SkeletonLoading>
  );
}
